import { useEffect } from 'react';
import { WebComponentUIContext } from '@weave/schema-gen-ts/dist/schemas/payments-platform/justifi-integration/justifi_integration.pb';
import { JustfiIntegration1 } from '@frontend/api-justifi-integration';

export type UseJustifiAuthTokenProps = {
  locationId?: string;
  businessId?: string;
  webComponentUiContext: WebComponentUIContext;
};
export const useJustifiAuthToken = ({ locationId, businessId, webComponentUiContext }: UseJustifiAuthTokenProps) => {
  /**
   * Load the auth token.
   * Can only be loaded once we have a business ID.
   */
  const {
    data: authToken,
    isLoading,
    refetch: refetchToken,
  } = JustfiIntegration1.Queries.useCreateWebComponentTokenQuery({
    request: {
      locationId: locationId || '',
      webComponentUiContext,
    },
    options: {
      enabled: !!locationId && !!businessId,
    },
  });

  useEffect(() => {
    const expiresAt = authToken?.expiresAt ? new Date(authToken?.expiresAt) : null;

    if (!expiresAt) {
      return;
    }

    const now = new Date();
    const diff = expiresAt.getTime() - now.getTime();

    /**
     * Set timeout to expire 2 minutes before the token expires
     */

    const timeout = setTimeout(() => {
      refetchToken();
    }, diff - 120000);

    return () => {
      clearTimeout(timeout);
    };
  }, [authToken]);

  return {
    authToken,
    isLoading: isLoading,
    refetchToken,
  };
};
